import Vue from 'vue';
import _ from 'lodash';

export default {
  namespaced: true,
  state: {
    app: {
      screen: {
        component: 'submenu-reports',
        tabComponent: 'tab-new-dashboard',
        modalComponent: '',
        modalAdditionalComponent: '',

        // Submenu screens
        reports: {
          tabList: {
            items: [
              {
                title: 'Dashboard',
              },
              {
                title: 'Content Distribution',
              },
              {
                title: 'Recent Tagging',
              },
              {
                title: 'Recent Document Processing',
              },
              {
                title: 'Index Analysis',
              },
              {
                title: 'Term Cloud',
              },
              {
                title: 'Classification Reports',
                dropdown: [],
              },
              {
                title: 'Clue Building Reports',
                dropdown: [],
              },
              {
                title: 'Document Reports',
                dropdown: [
                  {
                    title: 'Document Tagging',
                  },
                  {
                    title: 'Duplicate Detection',
                  },
                  {
                    title: 'Manual Tagging',
                  },
                  {
                    title: 'Near Duplicate Detection',
                  },
                  {
                    title: 'Page Statuses',
                  },
                ],
              },
              {
                title: 'System Reports',
                dropdown: [],
              },
            ],
            active: 0,
            subactive: 0,
            expanded: 0,
          },
          contentDistribution: {
            taxonomyValue: 'Please select',
            groupByRadio: {
              value: 'Taxonomy',
              disabled: true,
            },
            taxonomyDropdown: {
              items: [
                {
                  title: 'Obsolete',
                  disabled: false,
                },
                {
                  title: 'Trivial',
                  disabled: true,
                },
              ],
              selected: 'Please select',
              disabled: true,
            },
            sourceFilterRadio: {
              value: 'Include',
              disabled: true,
            },
            tileScreen: 1,
          },
        },
        termManagement: {
          sourceFilter: {
            value: '(None)',
          },
          termSearchField: {
            value: 'PCI DSS',
            disabled: true,
          },
          termTabSearchInput: {
            value: '',
            disabled: true,
          },
          termTabList: {
            active: 2,
            items: [
              'Clues',
              'Search',
              'Browse',
              'Working Set',
              'Related',
              'Graph',
              'Settings',
              'Logs',
            ],
          },
          termLists: {
            active: 0,
            selected: 0,
            items: [
              {
                disabled: true,
                items: [
                  'AMEX (1486 of 1486)',
                  'Diners Club (123 of 123)',
                  'Discover (65 of 65)',
                  'JCB (422 of 422)',
                  'Mastercard (1342 of 1342)',
                  'UnionPay (984 of 984)',
                  'Visa (677 of 677)',
                ],
              },
              {
                disabled: false,
                items: [
                  'AMEX (513 of 1486)',
                  'Mastercard (341 of 1342)',
                  'UnionPay (65 of 984)',
                  'Visa (166 of 677)',
                ],
              },
              {
                disabled: true,
                items: [
                  'AMEX (513 of 1486)',
                  'Mastercard (341 of 1342)',
                  'UnionPay (65 of 984)',
                  'Visa (166 of 677)',
                ],
              },
              {
                disabled: true,
                items: [
                  'Tax Returns (89 of 89)',
                  'Contracts (41 of 41)',
                  'Financial Audit Records (11 of 11)',
                  'Invoices (593 of 593)',
                  'HR records (678 of 678)',
                  'Legal filings (14 of 14)',
                  'Other Financial Records (124 of 124)',
                  'Obsolete Records (12 of 12)',
                ],
              },
              {
                disabled: true,
                items: [
                  'Release 4.0 Turaco (89 of 89)',
                  'Release 4.1 Stork (41 of 41)',
                  'Release 4.1.1 Eagle (11 of 11)',
                  'Release 5.0 Peafowl (123 of 123)',
                  'Release 5.5 Crane (78 of 78)',
                  'Release 6.0 Puffin (24 of 24)',
                  'Release 6.5 Bunting (89 of 89)',
                  'Release 7.0 Kittiwake (0 of 0)',
                ],
              },
              {
                disabled: true,
                items: [
                  'Release 4.0 Turaco (89 of 89)',
                  'Release 4.1 Stork (41 of 41)',
                  'Release 4.1.1 Eagle (11 of 11)',
                  'Release 5.0 Peafowl (123 of 123)',
                  'Release 5.5 Crane (78 of 78)',
                  'Release 6.0 Puffin (24 of 24)',
                  'Release 6.5 Bunting (89 of 89)',
                  'Release 7.0 Kittiwake (67 of 67)',
                ],
              },
              {
                disabled: true,
                items: [
                  'Release 4.0 Turaco (89 of 89)',
                  'Release 4.1 Stork (41 of 41)',
                  'Release 4.1.1 Eagle (11 of 11)',
                  'Release 5.0 Peafowl (123 of 123)',
                  'Release 5.5 Crane (78 of 78)',
                  'Release 6.0 Puffin (24 of 24)',
                  'Release 6.5 Bunting (89 of 89)',
                  'Release 7.0 Kittiwake (41 of 41)',
                ],
              },
            ],
          },
          termSuggestLists: {
            active: 0,
            visible: true,
            selectable: false,
            buttons: {
              active: false
            },
            items: [
              [
                {
                  showingText: 'Showing 5 of 1486 record(s)',
                  showCheckbox: false,
                  items: [
                    {
                      path: '\\\\fs\\Accounting\\Empolyees\\Q1Salary.docx',
                      percent: '78',
                      text: 'Mastercard (3) No bank 5564993339000765 No bank 5278755138230183 5410238466653002 5379720040567914 5140039227658406 Visa (3) 4485943991322691 4485929207269636 4916431682243805 4539 178131828390 4556526176514515 4556668474573486 4485501855863752 Dinners Club (5) 30047328206987 36688931997951 36250093425105 36530360370948 36687223020464 Discover 62229678361104 28 UnionPay (10) 6276616747019526 6250840674176261 6213174015699765 6257670755760466 6292479195933940 6215831914287012 6222967836110428 6243668590515894 6230021371514618 6280240143193993 JCB (2) 3530346629352469 3534064852970990 3533306799369591 3539810987526809 <span>AMEX</span> (6) <span>346313684963291</span> <span>340352458886615</span> <span>344635277152789</span> <span>347578941469188</span> <span>346402460940456</span> <span>343531613936131</span>',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Accounting\\Empolyees\\Q1Salary.docx',
                      filesize: '14KB',
                    },
                    {
                      path: '\\\\fs\\Global\\Sales\\Clients\\Credit Cards List.pdf',
                      percent: '68',
                      text: '<span>340352458886615</span>, 12/2022, 9135, <span>American Express</span>, USA, Nathaniel Kirby <br>' +
                          '<span>349903419152488</span>, 1/2021, 1009, <span>American Express</span>, Philippines, Noble Sanders <br>' +
                          '<span>374310990258684</span>, 6/2020, 4344, <span>American Express</span>, Netherlands, Madeleine Patrick <br>' +
                          '4902753393045575, 12/2025, 124, Visa, Chile, Tobias Rose <br>' +
                          '4501954361590130, 4/2020, 949, Visa, United Kingdom, Rolland Sharpe <br>' +
                          '2223129969730708, 08/2023, 901, Mastercard, Spain, Sebastian Mcpherson',
                      icon: 'pdf',
                      filepath: 'file:///\\\\fs\\Global\\Sales\\Clients\\Credit Cards List.pdf',
                      filesize: '26KB',
                    },
                    {
                      path: 'Server=SQL\\Enterprise, Database=Accounting, Table=dbo.SalarySeptember [CSSID157211_1]',
                      percent: '64',
                      text: '6222967836110420 Discover Bob Salior 6276616747019520 UnionPay Terry Stele 6250840674176260 UnionPay Adam West 6213174015699760 UnionPay Alex Clark 6257670755760460 UnionPay Wilbert Brooks 6236 0879 9187 5253 UnionPay Ivy Houston 8823 1676 3118 1927 UnionPay Bradford Clayton 6283 1825 4079 1291 UnionPay Gayle Newton 6281 2210 8819 5523 UnionPay JCB Alex Clark 3534064852970990 JCB Bob Sailor 3533306799369590 JCB Terry Stele 3539810987526800 JCB Adam West <span>340352458886615</span> AMEX Terry Stele <span>344635277152789</span> <span>AMEX</span> Adam West <span>347578941469188</span> <span>AMEX</span> Alex Clark <span>343531613936137</span> <span>AMEX</span> Jason Smith <span>346402460940456</span> <span>AMEX</span> Terry Stele <span>346313684963291</span> <span>AMEX</span>',
                      icon: 'file',
                      filepath: 'Server=SQL\\Enterprise, Database=Accounting, Table=dbo.SalarySeptember [CSSID157211_1]',
                      filesize: '112KB',
                    },
                    {
                      path: '\\\\fs\\Public\\Clients\\Personal data\\Peter Rogers.xlsx',
                      percent: '62',
                      text: '<span>373242124971638</span> <span>343715655273620</span> <span>349847416120966</span> 12/2024 2948 Peter Rogers <span>American Express</span> (Gold)',
                      icon: 'excel',
                      filepath: 'file:///\\\\fs\\Public\\Clients\\Personal data\\Peter Rogers.xlsx',
                      filesize: '6KB',
                    },
                    {
                      path: '\\\\fs\\Public\\Clients\\Personal data\\Ian Calderon.xlsx',
                      percent: '62',
                      text: '<span>375464767898732</span> <span>342394563301948</span> <span>371479393082398</span> 8/2021 6147 Ian Calderon <span>American Express</span> (Silver)',
                      icon: 'excel',
                      filepath: 'file:///\\\\fs\\Public\\Clients\\Personal data\\Ian Calderon.xlsx',
                      filesize: '6KB',
                    },
                  ],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
              ],
              [
                {
                  showingText: 'Showing 5 of 513 record(s)',
                  showCheckbox: true,
                  items: [
                    {
                      path: '\\\\fs\\Public\\Sales\\Credit Cards List.pdf',
                      percent: '75',
                      text: 'Gayle Newton 6281 2210 8819 5523 UnionPay JCB Alex Clark 3534064852970990 JCB Bob Sailor 3533306799369590 JCB Terry Stele 3539810987526800 JCB Adam West <span>340352458886615</span> AMEX Terry Stele <span>344635277152789</span> <span>AMEX</span> Adam West <span>347578941469188</span> <span>AMEX</span> Alex Clark <span>343531613936137</span> <span>AMEX</span> Jason Smith <span>346402460940456</span> <span>AMEX</span> Terry Stele <span>346313684963291</span> <span>AMEX</span>',
                      icon: 'pdf',
                      filepath: 'file:///\\\\fs\\Public\\Sales\\Credit Cards List.pdf',
                      filesize: '126KB',
                    },
                    {
                      path: '\\\\fs\\Public\\Sales\\Invoice162.docx',
                      percent: '79',
                      text: 'Invoice #162 Invoice date: 3/22/19 Service description: Logo design, Wireframes for Landing Page Quantity: 02 01 Rate: $500/week, $350/week Amount: $1000, $750 Total Services: $1750 Invoice due: 9/22/19 Discount: -$150 Tax(5%): $80 Total: 1680 Payment information: <span>374310990258684</span>, 6/2020, 4344, <span>American Express</span>, USA, Madeleine Manning. 4902753393045575, 12/2025, 124, Visa, United Kingdom, Cedrick Ellis. 2223129969730708, 08/2023, 901, Mastercard, Ireland, Walter Winters',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Public\\Sales\\Invoice162.docx ',
                      filesize: '114KB',
                    },
                    {
                      path: '\\\\fs\\Public\\Clients\\Bill234.docx',
                      percent: '72',
                      text: '234 Bill To: Jason Anderson, 156 Chester Groove street, Hungary, HU 1678. Ship To: Zackray Snow, 289 Morris Walk, Ireland, IE 7603. Code: SKU11232, Quantity: 27, Price: $1200, Line Total: 32400. Shipping: $20 Subtotal: $32400. Total: $32420. Payments (-)$0.00 Balance Due: $32420. Payment details:  2329328433950792 Mastercard 4621591598422516 Visa 4320014168193429 Visa 4640045406428238 Visa <span>348618404082885</span> <span>AMEX</span> <span>345931228238838</span> <span>AMEX</span>',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Public\\Clients\\Bill234.docx',
                      filesize: '34KB',
                    },
                    {
                      path: '\\\\fs\\Public \\Clients\\Personal data\\Peter Rogers.xlsx',
                      percent: '62',
                      text: '<span>373242124971638</span> <span>343715655273620</span> <span>349847416120966</span> 12/2024 2948 Peter Rogers <span>American Express</span> (Gold)',
                      icon: 'excel',
                      filepath: 'file:///\\\\fs\\Public\\Clients\\Personal data\\Peter Rogers.xlsx',
                      filesize: '6KB',
                    },
                    {
                      path: '\\\\fs\\Public\\Clients\\Personal data\\Ian Calderon.xlsx',
                      percent: '62',
                      text: '<span>375464767898732</span> <span>342394563301948</span> <span>371479393082398</span> 8/2021 6147 Ian Calderon <span>American Express</span> (Silver)',
                      icon: 'excel',
                      filepath: 'file:///\\\\fs\\Public\\Clients\\Personal data\\Ian Calderon.xlsx',
                      filesize: '6KB',
                    },
                  ],
                },
                {
                  showingText: 'Showing 5 of 341 record(s)',
                  showCheckbox: true,
                  items: [
                    {
                      path: '\\\\fs\\Public\\Sales\\Invoice162.docx',
                      percent: '79',
                      text: 'Invoice #162 Invoice date: 3/22/19 Service description: Logo design, Wireframes for Landing Page Quantity: 02 01 Rate: $500/week, $350/week Amount: $1000, $750 Total Services: $1750 Invoice due: 9/22/19 Discount: -$150 Tax(5%): $80 Total: 1680 Payment information: 374310990258684, 6/2020, 4344, American Express, USA, Madeleine Patrick. 4902753393045575, 12/2025, 124, Visa, United Kingdom, Tobias Rose. <span>2223129969730708</span>, 08/2023, 901, <span>Mastercard</span>, Spain, Sebastian Mcpherson',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Public\\Sales\\Invoice162.docx',
                      filesize: '14KB',
                    },
                    {
                      path: '\\\\fs\\Public\\Marketing\\EU_UrgentPay.pdf',
                      percent: '79',
                      text: '<span>2428668003425497</span>, 8/2020, 689, <span>Mastercard</span>, Tyrone Burton, Netherlands, Rotterdam <br>' +
                          '<span>2552389126147938</span>, 9/2024, 145, <span>Mastercard</span>, Daniel Proenca-Carneiro, Portugal, Porto<br>' +
                          '<span>2653853173129667</span>, 11/2023, 619, <span>Mastercard</span>, Marcel Simek, Czech Republic, Prague<br>' +
                          '<span>2281498693303044</span>, 5/2021, 451, <span>Mastercard</span>, Benedict Wells, United Kingdom, Liverpool<br>' +
                          '<span>2347517330626053</span>, 1/2020, 545, <span>Mastercard</span>, Cristopher Leroux, France, Nice',
                      icon: 'pdf',
                      filepath: 'file:///\\\\fs\\Public\\Marketing\\EU_UrgentPay.pdf ',
                      filesize: '26KB',
                    },
                    {
                      path: '\\\\fs\\Public\\Clients\\Bill234.docx',
                      percent: '68',
                      text: '234 Bill To: Jason Anderson, 156 Chester Groove street, Hungary, HU 1678. Ship To: Zackray Snow, 289 Morris Walk, Ireland, IE 7603. Code: SKU11232, Quantity:27, Price: $1200, Line Total: 32400. Shipping: $20 Subtotal: $32400. Total: $32420. Payments (-)$0.00 Balance Due: $32420. Payment details: <span>2329328433950792</span> <span>Mastercard</span> 4621591598422516 Visa 4320014168193429 Visa 4640045406428238 Visa 348618404082885 AMEX 345931228238838 AMEX',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Public\\Clients\\Bill234.docx',
                      filesize: '34KB',
                    },
                    {
                      path: '\\\\fs\\ Public\\Clients\\Personal data\\Zoe Ball.xlsx',
                      percent: '62',
                      text: '<span>2548695223864523</span> <span>2281639266016287</span> <span>2559141858905519</span> 12/2022 116 Zoe Ball <span>Mastercard</span>',
                      icon: 'excel',
                      filepath: 'file:///\\\\fs\\Public\\Clients\\Personal data\\Zoe Ball.xlsx',
                      filesize: '6KB',
                    },
                    {
                      path: '\\\\fs\\Public\\Clients\\Personal data\\Kailee Nicholson.xlsx',
                      percent: '62',
                      text: '<span>5167845262871003</span> <span>5281639273016287</span> <span>2567141858780510</span> 12/2022 116 Kailee Nicholson <span>Mastercard</span>',
                      icon: 'excel',
                      filepath: 'file:///\\\\fs\\Public\\Clients\\Personal data\\Kailee Nicholson.xlsx',
                      filesize: '6KB',
                    },
                  ],
                },
                {
                  showingText: 'Showing 5 of 65 record(s)',
                  showCheckbox: true,
                  items: [
                    {
                      path: '\\\\fs\\Public\\Accounting\\Empolyees\\Contract452.docx',
                      percent: '82',
                      text: 'Employment Contract #452 Name of Company: Enterprise Company’s Address: 54195 Hermina, 96 Cody Court Cambridge, Massachusetts, 02142, United States Name of Employee: Brand Elizabeth Employee’s Address 54195 Parkw Hall, Massachuse, 02142, United States Contractual Work Days: Monday-Friday Contractual Work Hours: 8am-5pm Contractual Monthly Salary: $4500 Salary Details: <span>6295356872840738</span> 7/2022 573 <span>UnionPay</span>',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Public\\Accounting\\Empolyees\\Contract452.docx',
                      filesize: '14KB',
                    },
                    {
                      path: '\\\\fs\\Public\\Sales\\Invoice67.pdf',
                      percent: '79',
                      text: 'Invoice #67 Invoice date: 8/22/19 Service description: Website design, Website development Quantity: 01 01 Rate: $700/week, $1000/week Amount: $700, $1000 Total Services: $1700 Invoice due: 8/22/19 Tax(5%): $85 Total: 1785 Payment information: <span>6218781594905861</span>, 7/2027, 381, <span>UnionPay</span>, France, Leroy Shaffer. <span>6231415042809432</span>, 5/2023, 957, <span>UnionPay</span> Eugenio Daugherty.',
                      icon: 'pdf',
                      filepath: 'file:///\\\\fs\\Public\\Sales\\Invoice67.pdf',
                      filesize: '26KB',
                    },
                    {
                      path: '\\\\fs\\Public\\Marketing\\ChinaUrgentPay.pdf',
                      percent: '79',
                      text: '<span>6227661079587500</span>, 10/2024, 768, <span>UnionPay</span>, Yun Li, China, Beijing <br>' +
                          '<span>6267384366347956</span>, 11/2020, 547, <span>UnionPay</span>, Xueguo Zhang, China, Shandong<br>' +
                          '<span>6255142136978623</span>, 8/2022, 156, <span>UnionPay</span>, Jianming Wang, China, Sichuan<br>' +
                          '<span>6298336442598104</span>, 7/2023, 876, <span>UnionPay</span>, Yun Zhang, China, Hangzhou',
                      icon: 'pdf',
                      filepath: 'file:///\\\\fs\\Public\\Marketing\\ChinaUrgentPay.pdf',
                      filesize: '16KB',
                    },
                    {
                      path: '\\\\fs\\public\\Clients\\Personal data\\Amia Mullen.xlsx',
                      percent: '62',
                      text: '<span>6258035841524855</span> <span>6249671566450494</span> <span>6249110500505453</span> 8/2025 468 Amia Mullen <span>UnionPay</span>',
                      icon: 'excel',
                      filepath: 'file:///\\\\fs\\Public\\Clients\\Personal data\\Amia Mullen.xlsx',
                      filesize: '6KB',
                    },
                    {
                      path: '\\\\fs\\public\\Clients\\Personal data\\Mitch Ray.xlsx',
                      percent: '62',
                      text: '<span>6298184554411116</span> <span>6267072986433039</span> <span>6285125391890538</span> 12/2022 854 Mitch Ray <span>UnionPay</span>',
                      icon: 'excel',
                      filepath: 'file:///\\\\fs\\Public\\Clients\\Personal data\\Mitch Ray.xlsx',
                      filesize: '6KB',
                    },
                  ],
                },
                {
                  showingText: 'Showing 5 of 166 record(s)',
                  showCheckbox: true,
                  items: [
                    {
                      path: '\\\\fs\\Public\\Sales\\Invoice162.docx',
                      percent: '79',
                      text: 'Invoice #162 Invoice date: 3/22/19 Service description: Logo design, Wireframes for Landing Page Quantity: 02 01 Rate: $500/week, $350/week Amount: $1000, $750 Total Services: $1750 Invoice due: 9/22/19 Discount: -$150 Tax(5%): $80 Total: 1680 Payment information: 374310990258684, 6/2020, 4344, American Express, USA, Madeleine Patrick. <span>4902753393045575</span>, 12/2025, 124, <span>Visa</span>, United Kingdom, Tobias Rose. 2223129969730708, 08/2023, 901, Mastercard, Spain, Sebastian Mcpherson',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Public\\Sales\\Invoice162.docx',
                      filesize: '14KB',
                    },
                    {
                      path: '\\\\fs\\Public\\Sales\\Clients\\Credit Cards List.pdf',
                      percent: '75',
                      text: '340352458886615, 12/2022, 9135, American Express, USA, Nathaniel Kirby <br>' +
                          '349903419152488, 1/2021, 1009, American Express, Philippines, Noble Sanders <br>' +
                          '374310990258684, 6/2020, 4344, American Express, Netherlands, Madeleine Patrick <br>' +
                          '<span>4902753393045575</span>, 12/2025, 124, <span>Visa</span>, Chile, Tobias Rose <br>' +
                          '<span>4501954361590130</span>, 4/2020, 949, <span>Visa</span>, United Kingdom, Rolland Sharpe <br>' +
                          '2223129969730708, 08/2023, 901, Mastercard, Spain, Sebastian Mcpherson',
                      icon: 'pdf',
                      filepath: 'file:///\\\\fs\\Public\\Sales\\Clients\\Credit Cards List.pdf',
                      filesize: '26KB',
                    },
                    {
                      path: '\\\\fs\\Public\\Clients\\Bill234.docx',
                      percent: '68',
                      text: '234 Bill To: Jason Anderson, 156 Chester Groove street, Hungary, HU 1678. Ship To: Zackray Snow, 289 Morris Walk, Ireland, IE 7603. Code: SKU11232, Quantity:27, Price: $1200, Line Total: 32400. Shipping: $20 Subtotal: $32400. Total: $32420. Payments (-)$0.00 Balance Due: $32420. Payment details: 2329328433950792 Mastercard <span>4621591598422516</span> <span>Visa</span> <span>4320014168193429</span> <span>Visa</span> <span>4640045406428238</span> <span>Visa</span> 348618404082885 AMEX 345931228238838 AMEX',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Public\\Clients\\Bill234.docx',
                      filesize: '34KB',
                    },
                    {
                      path: '\\\\fs\\public\\Clients\\Personal data\\Marco Santos.xlsx',
                      percent: '62',
                      text: '<span>4600100614028649</span> <span>4153830438279017</span> <span>4897619803715874</span> 6/2023 534 Marco Santos <span>Visa</span>',
                      icon: 'excel',
                      filepath: 'file:///\\\\fs\\Public\\Clients\\Personal data\\Marco Santos.xlsx',
                      filesize: '6KB',
                    },
                    {
                      path: '\\\\fs\\public\\Clients\\Personal data\\Carrol Ryan.xlsx',
                      percent: '62',
                      text: '<span>4666725974594235</span> <span>4306826972281985</span> <span>4035942125230387</span> 7/2020 678 Carrol Ryan <span>Visa</span>',
                      icon: 'excel',
                      filepath: 'file:///\\\\fs\\Public\\Clients\\Personal data\\Carrol Ryan.xlsx',
                      filesize: '6KB',
                    },
                  ],
                },
              ],
              [
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'Showing 5 of 41 record(s)',
                  items: [
                    {
                      path: '\\\\fs\\Accounting\\Contractors\\Contract_1468.pdf',
                      percent: '78',
                      text: 'This <span>contract</span> (the “<span>Contract</span>”) is made by and between OptiTech, a limited liability company, with a principal <span>place of business</span> in 5900-5940 Brampton Ave Phoenix, AZ 85033 (the “<span>Contractor</span>”), for the delivery of technical support services to SmartClean, a limited liability company, with a principal <span>place of business</span> in 5118-5180 N 61th Ave Glendale, AZ 85003 (the “<span>Client</span>”). Scope of service. <span>Contractor</span>, in exchange for the compensation under this <span>contract</span> agrees to provide technical support services to the <span>Client</span>.',
                      icon: 'pdf',
                      filepath: '\\\\fs\\Accounting\\Contractors\\Contract_1468.pdf',
                      filesize: '1454KB',
                    },
                    {
                      path: '\\\\fs\\Global\\Services\\Contracts\\Contract 2249(1).docx',
                      percent: '68',
                      text: '17. <span>Dispute Resolution</span>. If a <span>dispute</span> arises under this <span>Contract</span>, any party may take the matter to California state court, jurisdiction of the county of Alameda. OR If a <span>dispute</span> arises under this <span>Contract</span>, the <span>parties</span> agree to first try to resolve the <span>dispute</span> with the help of a mutually agreed-upon mediator in Alameda County, CA.',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Global\\Services\\Contracts\\Contract 2249(1).docx',
                      filesize: '451KB',
                    },
                    {
                      path: 'http://sp.enterprise.com/Documents/Projects/Support_Contract_new.pdf',
                      percent: '64',
                      text: 'Confidentiality. <span>Contractor</span> acknowledges that it will be necessary for <span>Client</span> to disclose certain confidential and proprietary information to <span>Contractor</span> in order for <span>Contractor</span> to perform duties under this <span>Contract</span>. <span>Contractor</span> acknowledges that disclosure to a third party or misuse of this proprietary or confidential information would irreparably harm <span>Client</span>.',
                      icon: 'pdf',
                      filepath: 'http://sp.enterprise.com/Documents/Projects/Support_Contract_new.pdf',
                      filesize: '1812KB',
                    },
                    {
                      path: '\\\\fs\\Accounting\\Contractors\\Contract_1519.tiff',
                      percent: '62',
                      text: '13. Term of <span>Contract</span>. This <span>Contract</span> will become effective when signed by both <span>parties</span> and will terminate on the earlier of: the date <span>Contractor</span> completes the services required by this <span>Contract</span>; the date a party terminates the <span>Contract</span> as provided below.',
                      icon: 'file',
                      filepath: 'file:///\\\\fs\\Accounting\\Contractors\\Contract_1519.tiff',
                      filesize: '1466KB',
                    },
                    {
                      path: '\\\\fs\\Accounting\\Contractors\\Contract 2249(1).docx',
                      percent: '62',
                      text: '<span>Contractor</span> acknowledges that any breach or threatened breach of Clause 18 of this <span>Contract</span> will result in irreparable harm to <span>Client</span> for which damages would be an inadequate remedy. Therefore, <span>Client</span> shall be entitled to equitable relief, including an injunction, in the event of such breach or threatened breach of Clause 18 of this <span>Contract</span>.',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Accounting\\Contractors\\Contract 2249(1).docx',
                      filesize: '866KB',
                    },
                  ],
                },
              ],
              [
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'Showing 5 of 85 record(s)',
                  items: [
                    {
                      path: '\\\\fs\\Development\\Release Documentation\\Kittiwake\\Release notes_draft(1).docx',
                      percent: '78',
                      text: 'Release notes. Changes included in this product <span>release 7.0 Kittiwake</span>: 1) The software now supports TIMT00326 version. 2) Standby Converter is now being detected for all supported versions. 3) Alarms: detection engine alerts on new types of errors. 4) Issue with output glitches on start-up is fixed. Improved reliability of calibration module for TIMT00326.',
                      icon: 'word',
                      filepath: 'file:/// \\\\fs\\ Development\\Release Documentation\\Kittiwake\\Release notes_draft(1).docx',
                      filesize: '1454KB',
                      checkbox: {
                        checked: false,
                      }
                    },
                    {
                      path: '\\\\fs\\Development\\Release Documentation\\Kittiwake\\Troubleshooting.docx',
                      percent: '68',
                      text: '<span>release 7.0 Kittiwake</span> The connected equipment exceeds the specified maximum load for TIMT00326. Refer to the APT for product specifications. The equipment will emit a sustained audible alarm until the overload condition is corrected. Disconnect nonessential equipment to correct the overload condition. Press any key to mute all audible alarms.',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Development\\Release Documentation\\Kittiwake\\Troubleshooting.docx ',
                      filesize: '451KB',
                      checkbox: {
                        checked: false,
                      }
                    },
                    {
                      path: '\\\\fs\\PM\\Releases\\Kittiwake\\TIMTupd.docx',
                      percent: '64',
                      text: 'Empty module entry should fail instead of just producing a WARNING [TIMT00316] - avoid hardcoded system classloader references [TIMT00317] - Toolchains should be read during initialization (<span>release 7.0</span>) - project-specific default jvm options and command line parameters [TIMT00318] - specify execution-id for direct plugin goal invocation from command line',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\PM\\Releases\\Kittiwake\\TIMTupd.docx',
                      filesize: '1812KB',
                      checkbox: {
                        checked: false,
                      }
                    },
                    {
                      path: '\\\\fs\\Development\\Release Documentation\\Kittiwake\\Task.docx',
                      percent: '62',
                      text: '<span>release 7.0</span> update TIMT to 00326 - Drop support for Win9x in mvn launch scripts - switch from 3.2.x to 3.3.x for calibration module for TIMT00326. - upgrade Java minimum version prerequisite from Java 6 to Java 7',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Development\\Release Documentation\\Kittiwake\\Task.docx',
                      filesize: '1466KB',
                    },
                    {
                      path: '\\\\fs\\PM\\Releases\\Kittiwake\\Configuration.docx',
                      percent: '62',
                      text: 'The old way was to create a jar (must be shaded if you have other dependencies) which contains the extension and put it manually into the ${HOME}/lib/ext folder. The consequence was that everyone who likes to use this needed to change it’s installation and makes the on-boarding for a developer much more inconvenient. In <span>release 7.0</span>',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\PM\\Releases\\Kittiwake\\Configuration.docx',
                      filesize: '866KB',
                    },
                  ],
                },
              ],
              [
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'Showing 5 of 41 record(s)',
                  items: [
                    {
                      path: '\\\\fs\\Development\\Release Documentation\\Kittiwake\\Release notes_draft(1).docx',
                      percent: '100',
                      text: '<span>Release notes</span>. Changes included in this product <span>release 7.0 Kittiwake</span>: 1) The software now supports <span>TIMT00326</span> version. 2) <span>Standby Converter</span> is now being detected for all supported versions. 3) Alarms: detection <span>engine alerts</span> on new types of errors. 4) Issue with output glitches on start-up is fixed. Improved reliability of calibration module for <span>TIMT00326</span>.',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Development\\Release Documentation\\Kittiwake\\Release notes_draft(1).docx',
                      filesize: '1454KB',
                    },
                    {
                      path: '\\\\fs\\Development\\Release Documentation\\Kittiwake\\Troubleshooting.docx',
                      percent: '100',
                      text: '<span>release 7.0 Kittiwake</span> The connected equipment exceeds the specified maximum load for <span>TIMT00326</span>. Refer to the APT for product specifications. The equipment will emit a sustained audible alarm until the <span>overload condition</span> is corrected. Disconnect nonessential equipment to correct the <span>overload condition</span>. Press any key to mute all audible alarms.',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Development\\Release Documentation\\Kittiwake\\Troubleshooting.docx',
                      filesize: '451KB',
                    },
                    {
                      path: 'http://sp.enterprise.com/Releases/Release5.0_notes_new.pdf',
                      percent: '64',
                      text: '<span>Release notes</span>. Changes included in this software release 5.0 Peafowl: 1) Fixed wrong summary output while using -T option. 2) Inconsistent classloading for extensions=true plugins. 3) Execution request ignores plugin repositories. 4) Provided an extension point to alternate CLI configuration mechanism. 5) Improved reliability of <span>calibration module</span> for alternate overload condition',
                      icon: 'pdf',
                      filepath: 'http://sp.enterprise.com/Releases/Release5.0_notes_new.pdf',
                      filesize: '1812KB',
                    },
                    {
                      path: '\\\\fs\\Development\\Release Documentation\\Kittiwake\\Task.docx',
                      percent: '62',
                      text: '<span>release 7.0</span> update TIMT to 00326 - Drop support for Win9x in mvn launch scripts - switch from 3.2.x to 3.3.x for calibration module for <span>TIMT00326</span>. - upgrade Java minimum version prerequisite from Java 6 to Java 7. <span>Standby Converter</span>',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Development\\Release Documentation\\Kittiwake\\Task.docx',
                      filesize: '1466KB',
                    },
                    {
                      path: '\\\\fs\\PM\\Releases\\Kittiwake\\TIMTupd.docx',
                      percent: '62',
                      text: 'Empty module entry should fail instead of just producing a WARNING [TIMT00316] - avoid hardcoded system classloader references [TIMT00317] - Toolchains should be read during initialization  (<span>release 7.0 Kittiwake</span>)  - project-specific default jvm options and command line parameters [TIMT00318] - specify execution-id for direct plugin goal invocation from command line',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\PM\\Releases\\Kittiwake\\TIMTupd.docx',
                      filesize: '866KB',
                    },
                  ],
                },
              ],
              [
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'No Records',
                  items: [],
                },
                {
                  showingText: 'Showing 5 of 41 record(s)',
                  items: [
                    {
                      path: '\\\\fs\\Development\\Release Documentation\\Kittiwake\\Release notes_draft(1).docx',
                      percent: '100',
                      alertRed: true,
                      alertText: 'Document score will decrease from 120 to 90',
                      text: '<span>Release notes</span>. Changes included in this product <span>release 7.0 Kittiwake</span>: 1) The software now supports <span>TIMT00326</span> version. 2) <span>Standby Converter</span> is now being detected for all supported versions. 3) Alarms: detection <span>engine alerts</span> on new types of errors. 4) Issue with output glitches on start-up is fixed. Improved reliability of calibration module for <span>TIMT00326</span>.',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Development\\Release Documentation\\Kittiwake\\Release notes_draft(1).docx',
                      filesize: '1454KB',
                    },
                    {
                      path: '\\\\fs\\Development\\Release Documentation\\Kittiwake\\Troubleshooting.docx',
                      percent: '100',
                      alertRed: false,
                      alertText: 'Document score will remain the same at 80',
                      text: '<span>release 7.0 Kittiwake</span> The connected equipment exceeds the specified maximum load for <span>TIMT00326</span>. Refer to the APT for product specifications. The equipment will emit a sustained audible alarm until the <span>overload condition</span> is corrected. Disconnect nonessential equipment to correct the <span>overload condition</span>. Press any key to mute all audible alarms.',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Development\\Release Documentation\\Kittiwake\\Troubleshooting.docx',
                      filesize: '451KB',
                    },
                    {
                      path: 'http://sp.enterprise.com/Releases/Release5.0_notes_new.pdf',
                      percent: '64',
                      alertRed: true,
                      alertText: 'Document score will decrease from 60 to 30',
                      text: '<span>Release notes</span>. Changes included in this software release 5.0 Peafowl: 1) Fixed wrong summary output while using -T option. 2) Inconsistent classloading for extensions=true plugins. 3) Execution request ignores plugin repositories. 4) Provided an extension point to alternate CLI configuration mechanism. 5) Improved reliability of <span>calibration module</span> for alternate overload condition',
                      icon: 'pdf',
                      filepath: 'http://sp.enterprise.com/Releases/Release5.0_notes_new.pdf',
                      filesize: '1812KB',
                    },
                    {
                      path: '\\\\fs\\Development\\Release Documentation\\Kittiwake\\Task.docx',
                      percent: '62',
                      alertRed: false,
                      alertText: 'Document score will remain the same at 65',
                      text: '<span>release 7.0</span> update TIMT to 00326 - Drop support for Win9x in mvn launch scripts - switch from 3.2.x to 3.3.x for calibration module for <span>TIMT00326</span>. - upgrade Java minimum version prerequisite from Java 6 to Java 7. <span>Standby Converter</span>',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\Development\\Release Documentation\\Kittiwake\\Task.docx',
                      filesize: '1466KB',
                    },
                    {
                      path: '\\\\fs\\PM\\Releases\\Kittiwake\\TIMTupd.docx',
                      percent: '62',
                      alertRed: false,
                      alertText: 'Document score will remain the same at 60',
                      text: 'Empty module entry should fail instead of just producing a WARNING [TIMT00316] - avoid hardcoded system classloader references [TIMT00317] - Toolchains should be read during initialization  (<span>release 7.0 Kittiwake</span>)  - project-specific default jvm options and command line parameters [TIMT00318] - specify execution-id for direct plugin goal invocation from command line',
                      icon: 'word',
                      filepath: 'file:///\\\\fs\\PM\\Releases\\Kittiwake\\TIMTupd.docx',
                      filesize: '866KB',
                    },
                  ],
                },
              ],
            ]
          },
          cluesList: {
            keywordInput: {
              value: '',
              disabled: false,
            },
            scoreInput: {
              value: '',
              disabled: true,
            },
            active: 0,
            editing: false,
            items: [
              [
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'contractor obligations',
                  clueLink: 'languages',
                  score: '20',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'contract term and termination',
                  clueLink: 'languages',
                  score: '20',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'place of business',
                  clueLink: 'languages',
                  score: '20',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'Client',
                  clueLink: 'languages',
                  score: '15',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'contractor',
                  clueLink: 'languages',
                  score: '15',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'contractual',
                  clueLink: 'languages',
                  score: '15',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'third party beneficiaries',
                  clueLink: 'languages',
                  score: '15',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'dispute resolution',
                  clueLink: 'languages',
                  score: '10',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'dispute',
                  clueLink: 'languages',
                  score: '5',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'parties',
                  clueLink: 'languages',
                  score: '5',
                  asterisk: false,
                },
              ],
              [
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'contract',
                  clueLink: 'languages',
                  score: '20',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'contractor obligations',
                  clueLink: 'languages',
                  score: '20',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'contract term and termination',
                  clueLink: 'languages',
                  score: '20',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'place of business',
                  clueLink: 'languages',
                  score: '20',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'Client',
                  clueLink: 'languages',
                  score: '15',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'contractor',
                  clueLink: 'languages',
                  score: '15',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'contractual',
                  clueLink: 'languages',
                  score: '15',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'third party beneficiaries',
                  clueLink: 'languages',
                  score: '15',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'dispute resolution',
                  clueLink: 'languages',
                  score: '10',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'dispute',
                  clueLink: 'languages',
                  score: '5',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'parties',
                  clueLink: 'languages',
                  score: '5',
                  asterisk: false,
                },
              ],
              [
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'release 7.0 Kittiwake',
                  clueLink: 'Languages',
                  score: '40',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'release notes',
                  clueLink: 'Languages',
                  score: '40',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'release 7.0',
                  clueLink: 'Languages',
                  score: '30',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'Kittiwake',
                  clueLink: 'Languages',
                  score: '25',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'TIMT00326',
                  clueLink: 'Languages',
                  score: '25',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'engine alert',
                  clueLink: 'Languages',
                  score: '10',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'overload condition',
                  clueLink: 'Languages',
                  score: '10',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'calibration module',
                  clueLink: 'Languages',
                  score: '10',
                  asterisk: false,
                },
                {
                  checked: false,
                  type: 'Standard',
                  clue: 'Standby Converter',
                  clueLink: 'Languages',
                  score: '10',
                  asterisk: false,
                },
              ],
            ],
          },
          footerData: {
            active: 0,
            items: [
              [
                {
                  numberOfItems: 1486,
                },
              ],
              [
                {
                  numberOfItems: 513,
                },
                {
                  numberOfItems: 341,
                },
                {
                  numberOfItems: 65,
                },
                {
                  numberOfItems: 166,
                },
              ],
              [
                {},
                {
                  numberOfItems: 41,
                },
              ],
              [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                  numberOfItems: 41,
                },
              ],
              [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                  numberOfItems: 41,
                },
              ],
            ],
          },
        },
        searches: {
          filters: {
            displayStatus: {
              active: 0,
              items: [
                'Active',
                'Completed',
                'All',
              ],
            },
            owner: {
              active: 0,
              items: [
                'All',
                'Mine',
              ],
            },
          },
          tableData: {
            activeSet: 0,
            sets: [
              [
                {
                  caseId: '713-586/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-03-01 10:14:13',
                  submittedBy: 'ENT\\J.Carter',
                  updatedDate: '2020-03-02 09:25:11',
                  filesIdentified: 21
                },
                {
                  caseId: '713-551/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-02-19 11:54:01',
                  submittedBy: 'ENT\\T.Simpson',
                  updatedDate: '2020-02-21 10:21:51',
                  filesIdentified: 34
                },
                {
                  caseId: '713-549/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-02-11 03:01:47',
                  submittedBy: 'ENT\\J.Carter',
                  updatedDate: '2020-02-15 11:54:01',
                  filesIdentified: 51
                },
                {
                  caseId: '711-434/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-02-21 05:41:43',
                  submittedBy: 'ENT\\J.Melnick',
                  updatedDate: '2020-02-21 11:47:10',
                  filesIdentified: 11
                },
                {
                  caseId: '713-531/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-02-05 12:00:43',
                  submittedBy: 'ENT\\J.Carter',
                  updatedDate: '2020-02-06 08:01:40',
                  filesIdentified: 14
                },
                {
                  caseId: '713-509/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-02-01 02:44:40',
                  submittedBy: 'ENT\\J.Carter',
                  updatedDate: '2020-02-08 09:40:41',
                  filesIdentified: 41
                },
                {
                  caseId: '711-414/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-01-26 04:03:17',
                  submittedBy: 'ENT\\J.Melnick',
                  updatedDate: '2020-01-29 11:14:11',
                  filesIdentified: 18
                },
                {
                  caseId: '713-508/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-01-19 11:10:14',
                  submittedBy: 'ENT\\T.Simpson',
                  updatedDate: '2020-01-25 11:54:01',
                  filesIdentified: 25
                },
                {
                  caseId: '713-498/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-01-09 11:51:11',
                  submittedBy: 'ENT\\T.Simpson',
                  updatedDate: '2020-01-18 10:14:13',
                  filesIdentified: 18
                },
                {
                  caseId: '713-811/2019',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2019-12-15 12:54:41',
                  submittedBy: 'ENT\\T.Simpson',
                  updatedDate: '2020-01-24 11:14:14',
                  filesIdentified: 81
                },
              ],
              [
                {
                  caseId: '711-434/2020',
                  status: 'Pending',
                  percentageComplete: 100,
                  submittedDate: '2020-03-31 11:25:31',
                  submittedBy: 'ENT\\J.Melnick',
                  updatedDate: '2020-03-31 11:25:31',
                  filesIdentified: 0,
                  storedDate: true,
                },
                {
                  caseId: '713-586/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-03-01 10:14:13',
                  submittedBy: 'ENT\\J.Carter',
                  updatedDate: '2020-03-02 09:25:11',
                  filesIdentified: 21
                },
                {
                  caseId: '713-551/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-02-19 11:54:01',
                  submittedBy: 'ENT\\T.Simpson',
                  updatedDate: '2020-02-21 10:21:51',
                  filesIdentified: 34
                },
                {
                  caseId: '713-549/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-02-11 03:01:47',
                  submittedBy: 'ENT\\J.Carter',
                  updatedDate: '2020-02-15 11:54:01',
                  filesIdentified: 51
                },
                {
                  caseId: '711-434/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-02-21 05:41:43',
                  submittedBy: 'ENT\\J.Melnick',
                  updatedDate: '2020-02-21 11:47:10',
                  filesIdentified: 11
                },
                {
                  caseId: '713-531/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-02-05 12:00:43',
                  submittedBy: 'ENT\\J.Carter',
                  updatedDate: '2020-02-06 08:01:40',
                  filesIdentified: 14
                },
                {
                  caseId: '713-509/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-02-01 02:44:40',
                  submittedBy: 'ENT\\J.Carter',
                  updatedDate: '2020-02-08 09:40:41',
                  filesIdentified: 41
                },
                {
                  caseId: '711-414/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-01-26 04:03:17',
                  submittedBy: 'ENT\\J.Melnick',
                  updatedDate: '2020-01-29 11:14:11',
                  filesIdentified: 18
                },
                {
                  caseId: '713-508/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-01-19 11:10:14',
                  submittedBy: 'ENT\\T.Simpson',
                  updatedDate: '2020-01-25 11:54:01',
                  filesIdentified: 25
                },
                {
                  caseId: '713-498/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-01-09 11:51:11',
                  submittedBy: 'ENT\\T.Simpson',
                  updatedDate: '2020-01-18 10:14:13',
                  filesIdentified: 18
                },
                {
                  caseId: '713-811/2019',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2019-12-15 12:54:41',
                  submittedBy: 'ENT\\T.Simpson',
                  updatedDate: '2020-01-24 11:14:14',
                  filesIdentified: 81
                },
              ],
              [
                {
                  caseId: '711-434/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-03-31 11:25:31',
                  submittedBy: 'ENT\\J.Melnick',
                  updatedDate: '2020-03-31 11:25:31',
                  filesIdentified: 10,
                  storedDate: true,
                },
                {
                  caseId: '713-586/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-03-01 10:14:13',
                  submittedBy: 'ENT\\J.Carter',
                  updatedDate: '2020-03-02 09:25:11',
                  filesIdentified: 21
                },
                {
                  caseId: '713-551/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-02-19 11:54:01',
                  submittedBy: 'ENT\\T.Simpson',
                  updatedDate: '2020-02-21 10:21:51',
                  filesIdentified: 34
                },
                {
                  caseId: '713-549/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-02-11 03:01:47',
                  submittedBy: 'ENT\\J.Carter',
                  updatedDate: '2020-02-15 11:54:01',
                  filesIdentified: 51
                },
                {
                  caseId: '711-434/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-02-21 05:41:43',
                  submittedBy: 'ENT\\J.Melnick',
                  updatedDate: '2020-02-21 11:47:10',
                  filesIdentified: 11
                },
                {
                  caseId: '713-531/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-02-05 12:00:43',
                  submittedBy: 'ENT\\J.Carter',
                  updatedDate: '2020-02-06 08:01:40',
                  filesIdentified: 14
                },
                {
                  caseId: '713-509/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-02-01 02:44:40',
                  submittedBy: 'ENT\\J.Carter',
                  updatedDate: '2020-02-08 09:40:41',
                  filesIdentified: 41
                },
                {
                  caseId: '711-414/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-01-26 04:03:17',
                  submittedBy: 'ENT\\J.Melnick',
                  updatedDate: '2020-01-29 11:14:11',
                  filesIdentified: 18
                },
                {
                  caseId: '713-508/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-01-19 11:10:14',
                  submittedBy: 'ENT\\T.Simpson',
                  updatedDate: '2020-01-25 11:54:01',
                  filesIdentified: 25
                },
                {
                  caseId: '713-498/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-01-09 11:51:11',
                  submittedBy: 'ENT\\T.Simpson',
                  updatedDate: '2020-01-18 10:14:13',
                  filesIdentified: 18
                },
                {
                  caseId: '713-811/2019',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2019-12-15 12:54:41',
                  submittedBy: 'ENT\\T.Simpson',
                  updatedDate: '2020-01-24 11:14:14',
                  filesIdentified: 81
                },
              ],
              [
                {
                  caseId: '711-434/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-03-31 11:25:31',
                  submittedBy: 'ENT\\J.Melnick',
                  updatedDate: '2020-03-31 11:25:31',
                  filesIdentified: 10,
                  storedDate: true,
                },
                {
                  caseId: '713-586/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-03-01 10:14:13',
                  submittedBy: 'ENT\\J.Carter',
                  updatedDate: '2020-03-02 09:25:11',
                  filesIdentified: 21
                },
                {
                  caseId: '713-551/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-02-19 11:54:01',
                  submittedBy: 'ENT\\T.Simpson',
                  updatedDate: '2020-02-21 10:21:51',
                  filesIdentified: 34
                },
                {
                  caseId: '713-549/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-02-11 03:01:47',
                  submittedBy: 'ENT\\J.Carter',
                  updatedDate: '2020-02-15 11:54:01',
                  filesIdentified: 51
                },
                {
                  caseId: '711-434/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-02-21 05:41:43',
                  submittedBy: 'ENT\\J.Melnick',
                  updatedDate: '2020-02-21 11:47:10',
                  filesIdentified: 11
                },
                {
                  caseId: '713-531/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-02-05 12:00:43',
                  submittedBy: 'ENT\\J.Carter',
                  updatedDate: '2020-02-06 08:01:40',
                  filesIdentified: 14
                },
                {
                  caseId: '713-509/2020',
                  status: 'Processed',
                  percentageComplete: 100,
                  submittedDate: '2020-02-01 02:44:40',
                  submittedBy: 'ENT\\J.Carter',
                  updatedDate: '2020-02-08 09:40:41',
                  filesIdentified: 41
                },
                {
                  caseId: '711-414/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-01-26 04:03:17',
                  submittedBy: 'ENT\\J.Melnick',
                  updatedDate: '2020-01-29 11:14:11',
                  filesIdentified: 18
                },
                {
                  caseId: '713-508/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-01-19 11:10:14',
                  submittedBy: 'ENT\\T.Simpson',
                  updatedDate: '2020-01-25 11:54:01',
                  filesIdentified: 25
                },
                {
                  caseId: '713-498/2020',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2020-01-09 11:51:11',
                  submittedBy: 'ENT\\T.Simpson',
                  updatedDate: '2020-01-18 10:14:13',
                  filesIdentified: 18
                },
                {
                  caseId: '713-811/2019',
                  status: 'Exported',
                  percentageComplete: 100,
                  submittedDate: '2019-12-15 12:54:41',
                  submittedBy: 'ENT\\T.Simpson',
                  updatedDate: '2020-01-24 11:14:14',
                  filesIdentified: 81
                },
              ],
            ],
          },
          pagination: {
            activeSet: 0,
            sets: [
              {
                showingText: 'Showing 10 record(s)',
                pageSize: [
                  {
                    pages: 10,
                    active: false,
                  },
                  {
                    pages: 25,
                    active: false,
                  },
                  {
                    pages: 50,
                    active: false,
                  },
                  {
                    pages: 100,
                    active: false,
                  },
                  {
                    pages: 200,
                    active: true,
                  },
                ]
              },
              {
                showingText: 'Showing 11 record(s)',
                pageSize: [
                  {
                    pages: 10,
                    active: false,
                  },
                  {
                    pages: 25,
                    active: false,
                  },
                  {
                    pages: 50,
                    active: false,
                  },
                  {
                    pages: 100,
                    active: false,
                  },
                  {
                    pages: 200,
                    active: true,
                  },
                ]
              },
            ],
          },
        },

        // Modals, @TODO Relocate modals to separate object
        addRequest: {
          caseId: '711-451/2020',
          lastName: 'Johnson',
          firstNames: 'Erica',
          emailAddress: {
            value: '',
            disabled: false,
          },
          reference: {
            value: '',
            disabled: true,
          },
          enableDateSearch: false,
        },
        addEmailNotification: {
          emailAddresses: {
            value: '',
            disabled: false,
          },
          tags: {
            activeSet: 0,
            sets: [
              [],
              ['privacy@enterprise.com'],
            ],
          },
        },
        addWorkflow: {
          step: 0,
          substep: 0,
          workflowName: 'PCI DSS Quarantine',
          documentTypeDropdown: {
            selected: 'Please select',
            active: 0,
            items: [
              [
                {
                  title: 'All types',
                  disabled: true,
                },
                {
                  title: 'Exchange',
                  disabled: true,
                },
                {
                  title: 'File',
                  disabled: false,
                },
                {
                  title: 'SharePoint',
                  disabled: true,
                },
                {
                  title: 'SQL',
                  disabled: true,
                },
                {
                  title: 'Oracle',
                  disabled: true,
                },
              ],
              [
                {
                  title: 'All types',
                  disabled: false,
                },
                {
                  title: 'Exchange',
                  disabled: true,
                },
                {
                  title: 'File',
                  disabled: true,
                },
                {
                  title: 'SharePoint',
                  disabled: true,
                },
                {
                  title: 'SQL',
                  disabled: true,
                },
                {
                  title: 'Oracle',
                  disabled: true,
                },
              ],
            ]
          },
          sourceDropdown: {
            selected: 'Please select',
            active: 0,
            items: [
              [
                {
                  title: '\\\\fs\\Sales',
                  disabled: true,
                },
                {
                  title: '\\\\fs\\Accounting',
                  disabled: true,
                },
                {
                  title: '\\\\fs\\HR',
                  disabled: true,
                },
                {
                  title: '\\\\fs\\Marketing',
                  disabled: true,
                },
                {
                  title: '\\\\fs\\Public',
                  disabled: false,
                },
                {
                  title: '\\\\fs\\Internal',
                  disabled: true,
                },
              ],
              [
                {
                  title: '\\\\fs\\Sales',
                  disabled: true,
                },
                {
                  title: '\\\\fs\\Accounting',
                  disabled: true,
                },
                {
                  title: '\\\\fs\\HR',
                  disabled: true,
                },
                {
                  title: '\\\\fs\\Marketing',
                  disabled: true,
                },
                {
                  title: '\\\\fs\\Public',
                  disabled: true,
                },
                {
                  title: '\\\\fs\\Internal',
                  disabled: true,
                },
              ],
            ],
          },
          repositoryTypeDropdown: {
            selected: 'Please select',
            disabled: false,
            active: 0,
            items: [
              [
                'File System',
              ],
              [
                'File System',
              ],
            ],
          },
          destinationDropdown: {
            selected: 'Please select',
            active: 0,
            items: [
              [
                '\\\\fs1\\Quarantine',
              ],
              [
                '\\\\fs1\\Archive',
              ],
              [
                '\\\\fs1\\Obsolete Records',
              ],
            ],
          },
          replicateRadio: {
            value: 'Yes',
            disabled: false,
          },
          copyormoveRadio: {
            value: 'Copy',
            disabled: false,
          },
          sourceReadOnlyRadio: {
            value: 'Yes',
            disabled: true,
          },
          actionRadio: {
            value: 'Replace',
            disabled: false,
          },
          redactRadio: {
            value: 'No',
            disabled: true,
          },
          redactionPlanDropdown: {
            selected: 'Please select',
            active: 0,
            items: [
              [
                'Mask Sensitive Info',
              ],
            ],
          },
          postMigrationRadio: {
            value: 'Yes',
            disabled: false,
          },
          recipientsInput: {
            value: '',
            disabled: false,
          },
          targetRadio: {
            value: 'Any Document',
            disabled: false,
          },
          specificDocument: 'Specific Classifications',
          notification: false,
          requireConditionRadio: {
            value: 'All',
            disabled: true,
          },
          tagList: {
            active: 0,
            items: [
              [],
              [
                'PCI DSS (All Terms)',
              ],
              [
                'Obsolete (All Terms)',
              ],
              [
                'Obsolete (All Terms)',
                'Trivial (All Terms)',
              ],
              [
                'Records (Outdated Records)',
              ],
              [
                'Product Releases (Release 7.0 Kittiwake)'
              ],
            ]
          },
          subjectInput: {
            value: 'Workflow Rule run on: [cs:Page Title]',
          },
          bodyInput: {
            value: 'A rule has been run on the following document: [cs:Page Title] Classifications: [cs:Classifications]',
          },
        },
        information: {
          file: '\\\\fs\\Public\\Sales\\Credit Cards List.pdf',
          tabList: {
            active: 4,
            items: [
              'Summary',
              'Text',
              'Metadata',
              'Classification',
              'Hit Counts',
              'Properties',
            ],
          },
        },
        details: {
          taxonomyDropdown: {
            selected: 'Please select',
            disabled: false,
            active: 0,
            items: [
              [
                {
                  title: 'Financial Records',
                  disabled: true,
                },
                {
                  title: 'GDPR',
                  disabled: true,
                },
                {
                  title: 'GDPR Restricted',
                  disabled: true,
                },
                {
                  title: 'GLBA',
                  disabled: true,
                },
                {
                  title: 'HIPAA',
                  disabled: true,
                },
                {
                  title: 'PCI DSS',
                  disabled: false,
                },
                {
                  title: 'PHI',
                  disabled: true,
                },
                {
                  title: 'PII',
                  disabled: true,
                },
              ],
              [
                {
                  title: 'Trivial',
                  disabled: false,
                },
                {
                  title: 'Obsolete',
                  disabled: true,
                },
                {
                  title: 'Language',
                  disabled: true,
                },
                {
                  title: 'File Type',
                  disabled: true,
                },
                {
                  title: 'GDPR',
                  disabled: true,
                },
                {
                  title: 'GDPR Restricted',
                  disabled: true,
                },
                {
                  title: 'PCI DSS',
                  disabled: true,
                },
                {
                  title: 'PHI',
                  disabled: true,
                },
                {
                  title: 'PII',
                  disabled: true,
                },
              ],
            ],
          },
          allTermsCheckbox: {
            checked: false,
            disabled: false,
          },
          termsTree: {
            active: 0,
            selected: false,
            value: '',
            items: [
              [
                'Obsolete Records',
                'Tax Returns',
                'Contracts',
                'Financial Audit Records',
              ],
              [
                'Release 5.5 Crane',
                'Release 6.0 Puffin',
                'Release 6.5 Bunting',
                'Release 7.0 Kittiwake',
              ],
            ],
          },
        },
        suggestClues: {
          items: [
            {
              active: false,
              clue: 'release 7.0 Kittiwake',
              score: 40,
              mandatory: false,
              type: 'Standard',
              checked: false,
            },
            {
              active: false,
              clue: 'release notes',
              score: 40,
              mandatory: false,
              type: 'Standard',
              checked: false,
            },
            {
              active: false,
              clue: 'release 7.0',
              score: 30,
              mandatory: false,
              type: 'Standard',
              checked: false,
            },
            {
              active: false,
              clue: 'Kittiwake',
              score: 25,
              mandatory: false,
              type: 'Standard',
              checked: false,
            },
            {
              active: false,
              clue: 'TIMT00326',
              score: 25,
              mandatory: false,
              type: 'Standard',
              checked: false,
            },
            {
              active: false,
              clue: 'engine alert',
              score: 10,
              mandatory: false,
              type: 'Standard',
              checked: false,
            },
            {
              active: false,
              clue: 'overload condition',
              score: 10,
              mandatory: false,
              type: 'Standard',
              checked: false,
            },
            {
              active: false,
              clue: 'calibration module',
              score: 10,
              mandatory: false,
              type: 'Standard',
              checked: false,
            },
            {
              active: false,
              clue: 'Standby Converter',
              score: 10,
              mandatory: false,
              type: 'Standard',
              checked: false,
            },
            {
              active: false,
              clue: 'product specifications',
              score: 7,
              mandatory: false,
              type: 'Standard',
              checked: false,
            },
            {
              active: false,
              clue: 'TIMT support',
              score: 5,
              mandatory: false,
              type: 'Standard',
              checked: false,
            },
            {
              active: false,
              clue: 'Setting',
              score: 5,
              mandatory: false,
              type: 'Standard',
              checked: false,
            },
            {
              active: false,
              clue: 'ext folder',
              score: 5,
              mandatory: false,
              type: 'Standard',
              checked: false,
            },
            {
              active: false,
              clue: 'webdav site',
              score: 5,
              mandatory: false,
              type: 'Standard',
              checked: false,
            },
            {
              active: false,
              clue: 'SSL client-side',
              score: 5,
              mandatory: false,
              type: 'Standard',
              checked: false,
            },
          ],
        },
      },
      menu: {
        itemHovered: null,
        itemActive: 2,
        dropdownItemActive: 0,
        itemsEnabled: [null],
        dropdownItemsEnabled: [null],
        items: [
          {
            regularIcon: 'content_configuration_ico.svg',
            activeIcon: 'content_configuration_disabled_ico.svg',
            text: 'Content Configuration',
            dropdown: {
              items: [
                {
                  regularIcon: 'sources_ico.svg',
                  activeIcon: 'sources_white_ico.svg',
                  text: 'Sources',
                },
                {
                  regularIcon: 'taxonomies_ico.svg',
                  activeIcon: 'taxonomies_white_ico.svg',
                  text: 'Taxonomies',
                },
                {
                  regularIcon: 'wokflows_ico.svg',
                  activeIcon: 'wokflows_white_ico.svg',
                  text: 'Workflows',
                },
              ],
            },
          },
          {
            regularIcon: 'system_configuration_ico.svg',
            activeIcon: 'system_configuration_disabled_ico.svg',
            text: 'System configuration',
            dropdown: {
              items: [
                {
                  icon: '',
                  text: 'Config',
                },
                {
                  icon: '',
                  text: 'User',
                },
              ],
            },
          },
          {
            regularIcon: 'data_analysis_ico.svg',
            activeIcon: 'data_analysis_disabled_ico.svg',
            text: 'Data analysis',
            dropdown: {
              items: [
                {
                  regularIcon: 'reports_ico.svg',
                  activeIcon: 'reports_white_ico.svg',
                  text: 'Reports',
                },
                {
                  regularIcon: 'dsar_ico.svg',
                  activeIcon: 'dsar_white_ico.svg',
                  text: 'DSAR',
                },
              ],
            },
          },
          {
            regularIcon: 'dashboard_ico.svg',
            activeIcon: 'dashboard_disabled_ico.svg',
            text: 'Dashboard',
            dropdown: {
              items: [],
            },
          },
          {
            regularIcon: 'help_ico.svg',
            activeIcon: 'help_disabled_ico.svg',
            text: 'Help',
            dropdown: {
              items: [],
            },
          },
        ],
      },
      submenu: {
        items: [
          [
            [],
            ['Term Management',
              'Graph',
              'Rollback',
              'User Edits',
              'Bulk Updates',
              'Taxonomy Settings',
              'Global Settings',
              'Help',],
            [],
          ],
          [],
          [
            [
              'Reports',
              'Queued Reports',
            ],
            [
              'Searches',
              'Settings',
            ],
          ],
          [],
        ],
        active: 0,
      },
      customViewareas: {
        frame0: false,
        frame1: false,
        frame2: false,
        frame3: false,
        frame4: false,
        frame5: false,
        frame6: false,
        frame7: false,
      },
      storedDates: {
        date1: '',
        date2: '',
      },
    },
  },
  mutations: {
    change(state, data) {
      for (const key in data) {
        const obj = _.merge(state.app[key], data[key]);
        Vue.set(state.app, key, obj);
      }
    },
    resetSuggestListCheckboxes(state) {
      const items = state.app.screen.termManagement.termSuggestLists.items[3][7].items;

      for (const key in items) {
        if (items[key].checkbox) {
          items[key].checkbox.checked = false;
        }
      }
    },
    resetSuggestCluesModalCheckboxes(state) {
      const items = state.app.screen.suggestClues.items;
      for (const key in items) {
        if (items[key]) {
          items[key].checked = false;
        }
      }
    },
    resetCluesListScore(state) {
      state.app.screen.termManagement.cluesList.items[2][1].score = '40';
    },
  },
  getters: {
    app: state => {
      return state.app;
    },
  },
  actions: {
    change({ commit }, data) {
      commit('change', data);
    },
    resetSuggestListCheckboxes({ commit }) {
      commit('resetSuggestListCheckboxes');
    },
    resetSuggestCluesModalCheckboxes({ commit }) {
      commit('resetSuggestCluesModalCheckboxes');
    },
    resetCluesListScore({ commit }) {
      commit('resetCluesListScore');
    },
  },
}